import { stVars } from '../Foundation/stylable/spacing.st.css.js';
export const DIRECTION = {
    horizontal: 'horizontal',
    vertical: 'vertical',
};
export const HORIZONTAL_ALIGNMENT = {
    left: 'left',
    center: 'center',
    right: 'right',
    'space-between': 'space-between',
};
export const VERTICAL_ALIGNMENT = {
    top: 'top',
    middle: 'middle',
    bottom: 'bottom',
    'space-between': 'space-between',
};
export const SPACING = {
    tiny: stVars.SP1,
    small: stVars.SP2,
    medium: stVars.SP3,
    large: stVars.SP4,
};
//# sourceMappingURL=Box.constants.js.map